import { normalizeIpCity } from "@shared/location/normalizeIpCity"
import { GeoCity, GeoProviderReturnType } from "./types";
import { useGetLocationQuery } from "@app/data/location/locationApi";
import { useAppDispatch, useAppSelector } from "@app/hooks";
import { selectCurrentLocation, selectLastLocation } from "@shared/location/selectors";
import { addLocationIp } from "@shared/location/locationSlice";
import { useEffect } from "react";


const useGeoProvider = ():GeoProviderReturnType => {
  const lastLocation = useAppSelector(selectLastLocation)
  const currentLocation = useAppSelector(selectCurrentLocation)
  const dispatch = useAppDispatch()
  const { data } = useGetLocationQuery()
  const setLocation = (location:GeoCity) => {
    dispatch(addLocationIp(location))
  }
  useEffect(() => {
    if (data && !currentLocation) {
      // Город по IP приводим к городу из нашего списка (мобильный IP часто указывает не туда)
      setLocation(normalizeIpCity(data as { city?: string; region?: string }) as GeoCity)
    }
  }, [data])


  return [currentLocation ?? lastLocation, setLocation]
}
export default useGeoProvider